module.exports = __webpack_public_path__ + "img/1.08a0b819.jpg";